module.exports = __webpack_public_path__ + "static/media/ckn_reporte_filtro.9be3c04a.jpg";